import { FC } from 'react';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import {
	ActionIcon,
	Anchor,
	Box,
	Drawer,
	Flex,
	Image,
	Text,
} from '@mantine/core';
import { creatorActions } from '@/store/slices/creatorSlice';
import { RichText } from '@/components/ui/richText/RichText';
import { useContent } from '@/providers/ContentProvider';
import ArrowLeftIcon from '@/assets/icons/arrowLeft.svg?react';

const baseSlug = 'creatorHelpDrawer.';

export const CreatorHelpDrawer: FC = () => {
	const dispatch = useTypedDispatch();

	const { getContent } = useContent();

	const { options } = useTypedSelector((state) => state.creator);

	const handleClose = () => {
		dispatch(creatorActions.updateOptions({ helpDrawerOpened: false }));
	};

	return (
		<Drawer
			opened={options.helpDrawerOpened}
			onClose={handleClose}
			title={
				<Flex gap="sm" align="center">
					<ActionIcon onClick={handleClose} variant="transparent">
						<ArrowLeftIcon />
					</ActionIcon>
					<Text size="lg" fw="bold">
						{options.helpDrawerData?.title}
					</Text>
				</Flex>
			}
		>
			<Image
				src={options.helpDrawerData?.image}
				mb="md"
				mah={300}
				fit="cover"
			/>

			{!!options.helpDrawerData?.description && (
				<Text size="sm" mt="lg" c="dimmed" span>
					<RichText raw={options.helpDrawerData.description} />
				</Text>
			)}
			{!!options.helpDrawerData?.dimensions && (
				<Box mt="lg">
					<Text mb="xs">{getContent(`${baseSlug}dimensions`)}</Text>
					<Text size="sm" c="dimmed" className="white-space-pre-line">
						{options.helpDrawerData.dimensions}
					</Text>
				</Box>
			)}
			<Flex mt="lg" align="center" justify="space-between">
				{!!options.helpDrawerData?.shopUrl && (
					<Anchor
						href={options.helpDrawerData.shopUrl}
						target="_blank"
						rel="noopener noreferrer"
						display="block"
						c="black"
						underline="always"
						fw="bold"
					>
						{getContent(`${baseSlug}viewInShop`)}
					</Anchor>
				)}
			</Flex>
		</Drawer>
	);
};
